/*!
 * Payment Gateway Components - built with StencilJS
 */
import{s as setupConfig}from"./environment-config-ba97848a.js";setupConfig({environment:"development"});